
import { Link } from 'react-router-dom';
import css from './ViewCertificateButton.module.css'

function ViewCertificateButton ({certificateLink}) {


    return (
        <>
        {certificateLink ? (
            <Link to={certificateLink} target="_blank" rel="noopener noreferrer">
                <i className={`${css.certIcon} fa-solid fa-award`}></i>
                {/* <button className={css.viewButton}>View</button> */}
            </Link>
        ) : (
            <></>
        )}
        </>
    )
}

export default ViewCertificateButton;